<template>
  <section class="timeline-container timeline">
    <template v-for="(event, index) in events" >
      <div v-bind:key="'event_' + index" class="timeline-block">
        <div class="timeline-img" :class="['timeline-img',getColorClass(event.type)]">
          <i class="fas" :class="getIcon(event.type)"></i>
        </div>

        <div class="timeline-content">
          <div class="container">
            <div class="row justify-content-md-left">
              <div class="col col-md-6 title label" v-if="event.type === 'DEVIATION'">{{ $t('shopfloor.trackAndTrace.deviation.' + event.deviationType) }}</div>
              <div class="col col-md-12 title label" v-else-if="event.type === 'STATUS_CODE'">{{ getStatusCodeTitle(event.statusCode) }}</div>
              <div class="col col-md-6 title label" v-else-if="event.type === 'UNDONE_DEVIATION'">{{ $t('shopfloor.trackAndTrace.eventTitles.' + event.type )}}: {{$t('shopfloor.trackAndTrace.deviation.' + event.deviationType)}}</div>
              <div class="col col-md-6 title label" v-else>{{ $t('shopfloor.trackAndTrace.eventTitles.' + event.type )}}</div>
              <div class="col col-md-6 title username" v-if="event.type !== 'STATUS_CODE'">{{ event.userName }}</div>
            </div>
            <div class="row justify-content-md-left" v-if="event.packingListNumber">
              <div class="col col-md-auto">
                <div class="label">{{$t('shopfloor.trackAndTrace.packingListNumber')}}:</div>
                <div class="value">{{ event.packingListNumber }}</div>
              </div>
            </div>

            <template v-if="event.type === 'USER_UNLOAD'">
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.sourceCargoReference')}}:</div>
                  <div class="value">{{ event.sourceCargoReference }}</div>
                </div>
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.destinationLocation')}}:</div>
                  <div class="value">{{ event.destinationLocation }}</div>
                </div>
              </div>
            </template>

            <template v-if="event.type === 'FICTIONAL_UNLOAD'">
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.sourceCargoReference')}}:</div>
                  <div class="value">{{ event.sourceCargoReference }}</div>
                </div>
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.destinationLocation')}}:</div>
                  <div class="value">{{ event.destinationLocation }}</div>
                </div>
              </div>
            </template>

            <template v-if="event.type === 'STOCK_CHANGE_UNLOAD'">
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.destinationLocation')}}:</div>
                  <div class="value">{{ event.destinationLocation }}</div>
                </div>
              </div>
            </template>

            <template v-if="event.type === 'STOCK_CHANGE'">
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.sourceLocation')}}:</div>
                  <div class="value">{{ event.sourceLocation }}</div>
                </div>
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.destinationLocation')}}:</div>
                  <div class="value">{{ event.destinationLocation }}</div>
                </div>
              </div>
            </template>


            <template v-if="event.type === 'DEVIATION'">
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.declaredDuring')}}:</div>
                  <div class="value">{{$t('shopfloor.trackAndTrace.declaredDuringLocations.' + event.location )}}</div>
                </div>
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.amount')}}:</div>
                  <div class="value">{{ event.amount }}</div>
                </div>
              </div>
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.cargoReference')}}:</div>
                  <div class="value">{{ event.cargoReference }}</div>
                </div>
              </div>
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.deviationNote')}}:</div>
                  <div class="value">{{ event.remark ? event.remark : '-' }}</div>
                </div>
              </div>

            </template>

            <template v-if="event.type === 'USER_LOAD'">
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.sourceLocation')}}:</div>
                  <div class="value">{{ event.sourceLocation }}</div>
                </div>
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.destinationCargoReference')}}:</div>
                  <div class="value">{{ event.destinationCargoReference }}</div>
                </div>
              </div>
            </template>

            <template v-if="event.type === 'MANUAL_ADJUSTMENT_BARCODE_UNREADABLE_CHANGED'">
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label">{{$t('shopfloor.trackAndTrace.barcodeUnreadableChanged')}}:</div>
                  <div class="value">{{ event.barcodeUnreadable === 'true' ? $t('shopfloor.trackAndTrace.barcodeUnreadableChangedYes') : $t('shopfloor.trackAndTrace.barcodeUnreadableChangedNo')  }}</div>
                </div>
                <div class="col col-md-auto" v-if="event.pickLocationAtThatTime">
                  <div class="label">{{$t('shopfloor.trackAndTrace.manualChangeAppliesToPickLocation')}}:</div>
                  <div class="value">{{ event.pickLocationAtThatTime }}</div>
                </div>
              </div>
            </template>

            <template v-if="event.type === 'MANUAL_ADJUSTMENT_PICKED_CHANGED'">
              <div>
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label" v-if="getManualChangeType(event.manualChangesPicked).type == 'increment'">{{$t('shopfloor.trackAndTrace.manualAdjustmentPickedIncrement')}}:</div>
                  <div class="label" v-if="getManualChangeType(event.manualChangesPicked).type == 'decrement'">{{$t('shopfloor.trackAndTrace.manualAdjustmentPickedDecrement')}}:</div>
                  <div class="value">{{ getManualChangeType(event.manualChangesPicked).value }}</div>
                </div>
                <div class="col col-md-auto" v-if="event.pickLocationAtThatTime">
                  <div class="label">{{$t('shopfloor.trackAndTrace.manualChangeAppliesToPickLocation')}}:</div>
                  <div class="value">{{ event.pickLocationAtThatTime }}</div>
                </div>
              </div>
              </div>
            </template>

            <template v-if="event.type === 'MANUAL_ADJUSTMENT_TO_PICK_CHANGED'">
              <div>
              <div class="row justify-content-md-left">
                <div class="col col-md-auto">
                  <div class="label" v-if="getManualChangeType(event.manualChangesToPick).type == 'increment'">{{$t('shopfloor.trackAndTrace.manualAdjustmentToPickIncrement')}}:</div>
                  <div class="label" v-if="getManualChangeType(event.manualChangesToPick).type == 'decrement'">{{$t('shopfloor.trackAndTrace.manualAdjustmentToPickDecrement')}}:</div>
                  <div class="value">{{ getManualChangeType(event.manualChangesToPick).value }}</div>
                </div>
                <div class="col col-md-auto" v-if="event.pickLocationAtThatTime">
                  <div class="label">{{$t('shopfloor.trackAndTrace.manualChangeAppliesToPickLocation')}}:</div>
                  <div class="value">{{ event.pickLocationAtThatTime }}</div>
                </div>
              </div>
              </div>
            </template>

          </div>
          <span class="date" v-text="parseDate(event.eventTimeStamp)"></span>
        </div>
      </div>
    </template>

  </section>
</template>
<script>

export default {
  props: {
    events: {
      required: true
    }
  },
  data() {
    return {}
  },
  components: {},
  methods: {
    parseDate(jsonDate) {
      return moment(new Date(jsonDate)).format('HH:mm DD-MM-YYYY')
    },
    calculateNewValue(previousValue, change) {
      let newValue = parseInt(previousValue) + parseInt(change);
      // console.log("previousValue", previousValue, change, newValue)
      return isNaN(newValue) ? 'Onbekend' : newValue;
    },
    getManualChangeType(value) {
      return {
        value: Math.abs(value),
        type: value > 0 ? 'increment' : 'decrement'
      }
    },
    getColorClass(type) {
      if (type === 'USER_UNLOAD') {
        return 'userUnload';
      } else if (type === 'STOCK_CHANGE_UNLOAD') {
        return 'stockChangeUnload';
      } else if (type === 'UNDONE_DEVIATION_UNLOAD') {
        return 'undoneDeviationUnload';
      } else if (type === 'FICTIONAL_UNLOAD') {
        return 'fictionalUnload';
      } else if (type === 'STOCK_CHANGE') {
        return 'stockChange';
      } else if (type === 'DEVIATION') {
        return 'deviation';
      } else if (type === 'USER_LOAD') {
        return 'userLoad';
      } else if (type === 'STATUS_CODE') {
        return 'statusCode';
      } else if (type === 'UNDONE_DEVIATION') {
        return 'undoneDeviation';
      } else if (type === 'STOP_IMPORT') {
        return 'stopImport';
      } else if (type === 'START_IMPORT') {
        return 'startImport';
      } else if (type === 'MANUAL_ADJUSTMENT_BARCODE_UNREADABLE_CHANGED') {
        return 'barcodeUnreadableChangedManually';
      } else if (type === 'MANUAL_ADJUSTMENT_TO_PICK_CHANGED') {
        return 'toPickChangedManually';
      } else if (type === 'MANUAL_ADJUSTMENT_PICKED_CHANGED') {
        return 'pickedChangeManually';
      }
    },
    getIcon(type) {
      if (type === 'USER_UNLOAD') {
        return 'fa-truck-ramp';
      } else if (type === 'STOCK_CHANGE_UNLOAD') {
        return 'fa-parachute-box';
      } else if (type === 'UNDONE_DEVIATION_UNLOAD') {
        return 'fa-box-heart';
      } else if (type === 'FICTIONAL_UNLOAD') {
        return 'fa-hand-holding-box';
      } else if (type === 'STOCK_CHANGE') {
        return 'fa-pallet';
      } else if (type === 'DEVIATION') {
        return 'fa-exclamation-triangle';
      } else if (type === 'USER_LOAD') {
        return 'fa-truck-loading';
      } else if (type === 'STATUS_CODE') {
        return 'fa-flag';
      } else if (type === 'UNDONE_DEVIATION') {
        return 'fa-band-aid';
      } else if (type === 'STOP_IMPORT') {
        return 'fa-ban';
      } else if (type === 'START_IMPORT') {
        return 'fa-check';
      } else if (type === 'MANUAL_ADJUSTMENT_BARCODE_UNREADABLE_CHANGED') {
        return 'fa-barcode-alt';
      } else if (type === 'MANUAL_ADJUSTMENT_TO_PICK_CHANGED') {
        return 'fa-user-edit';
      } else if (type === 'MANUAL_ADJUSTMENT_PICKED_CHANGED') {
        return 'fa-user-edit';
      }
    },
    getStatusCodeTitle(statusCode) {
      const knownStatusCodes = ['100', '110', '130', '140', '150', '160', '170', '173', '174', '180', '181', '182', '183', '184', '185', '186', '190', '193', '200', '210', '220', '230', '240', '250', '260', '270', '280', '290', '901', '902'];
      if (knownStatusCodes.indexOf(statusCode) === -1) {
        return `${this.$t('shopfloor.trackAndTrace.statusCode')} ${statusCode}`
      } else {
        return `${this.$t('shopfloor.trackAndTrace.statusCode')} ${statusCode}: ${this.$t('shopfloor.trackAndTrace.statusCodes.' + statusCode)}`
      }
    }
  }
}
</script>
<style scoped>
.timeline-container {
  /* this class is used to give a max-width to the element it is applied to, and center it horizontally when it reaches that max-width */
  width: 90%;
  max-width: 1170px;
  margin: 0 auto;
}

.label {
  font-weight: bold;
  min-width: 5rem;
}

.value {
  margin-left: 1rem;
}

.username {
  text-align: right;
}

.value, .label {
  display: inline;
}

.title {
  font-size: 1.5rem;
  color: #373737;
}

.timeline-container::after {
  /* clearfix */
  content: '';
  display: table;
  clear: both;
}

.container {
  padding: unset;
}

/* --------------------------------

Main components

-------------------------------- */

.timeline {
  position: relative;
  padding: 2em 0;
  margin-top: 2em;
  margin-bottom: 2em;
}

.timeline::before {
  /* this is the vertical line */
  content: '';
  position: absolute;
  top: 0;
  left: 18px;
  height: 100%;
  width: 4px;
  background: #f7f7f7;
}

@media only screen and (min-width: 1170px) {
  .timeline {
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .timeline::before {
    left: 50%;
    margin-left: -2px;
  }
}

.timeline-block {
  position: relative;
  margin: 2em 0;
}

.timeline-block:after {
  content: "";
  display: table;
  clear: both;
}

.timeline-block:first-child {
  margin-top: 0;
}

.timeline-block:last-child {
  margin-bottom: 0;
}

@media only screen and (min-width: 1170px) {
  .timeline-block {
    margin: 4em 0;
  }

  .timeline-block:first-child {
    margin-top: 0;
  }

  .timeline-block:last-child {
    margin-bottom: 0;
  }
}

.timeline-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 0 0 4px white, inset 0 2px 0 rgba(0, 0, 0, 0.08), 0 3px 0 4px rgba(0, 0, 0, 0.05);
  align-items: center;
  align-content: center;
  display: grid;
  text-align: center;
  font-size: 2rem;
}

.timeline-img i {

}

.timeline-img.userUnload {
  background: #00C9FF;
  color: white;
}
.timeline-img.stockChangeUnload {
  background: #7ce4ff;
  color: white;
}
.timeline-img.fictionalUnload {
  background: #7ce4ff;
  color: white;
}
.timeline-img.undoneDeviationUnload {
  background: #7ce4ff;
  color: white;
}
.timeline-img.stockChange {
  background: #7ce4ff;
  color: white;
}
.timeline-img.deviation {
  background: #FE4C4C;
  color: white;
}
.timeline-img.userLoad {
  background: #00C9FF;
  color: white;
}
.timeline-img.statusCode {
  background: #ffdda8;
  color: white;
}
.timeline-img.undoneDeviation {
  background: #a1ce57;
  color: white;
}
.timeline-img.stopImport {
  background: #ffb236;
  color: white;
}

.timeline-img.startImport {
  background: #ffb236;
  color: white;
}

.timeline-img.barcodeUnreadableChangedManually {
  background: #a7a7a7;
  color: white;
}

.timeline-img.toPickChangedManually {
  background: #7ce4ff;
  color: white;
}

.timeline-img.pickedChangeManually {
  background: #7ce4ff;
  color: white;
}

 .toPickChangedManually > i, .pickedChangeManually > i {
  margin-left: 0.6rem;
}

.fa-exclamation-triangle {
  color: unset !important;
  font-size: unset !important;
  margin-right: unset !important;
  float: unset !important;
}


@media only screen and (min-width: 1170px) {
  .timeline-img {
    width: 60px;
    height: 60px;
    left: 50%;
    margin-left: -30px;
    /* Force Hardware Acceleration in WebKit */
    -webkit-transform: translateZ(0);
    -webkit-backface-visibility: hidden;
  }

  .cssanimations .timeline-img.is-hidden {
    visibility: hidden;
  }

  .cssanimations .timeline-img.bounce-in {
    visibility: visible;
    -webkit-animation: bounce-1 0.6s;
    -moz-animation: bounce-1 0.6s;
    animation: bounce-1 0.6s;
  }
}

.timeline-content {
  position: relative;
  margin-left: 60px;
  background: white;
  border-radius: 0.25em;
  padding: 1rem;
  box-shadow: rgba(69, 65, 78, 0.08) 0px 1px 15px 1px;
}

.timeline-content:after {
  content: "";
  display: table;
  clear: both;
}

.timeline-content h2 {
  color: #303e49;
}

.timeline-content .read-more, .timeline-content .date {
  display: inline-block;
}

.timeline-content p {
  margin: 1em 0;
  line-height: 1.6;
}

.timeline-content .read-more {
  float: right;
  padding: .8em 1em;
  background: #acb7c0;
  color: white;
  border-radius: 0.25em;
}

.no-touch .timeline-content .read-more:hover {
  background-color: #bac4cb;
}

a.read-more:hover {
  text-decoration: none;
  background-color: #424242;
}

.timeline-content .date {
  float: left;
  padding-top: 0.5rem;
  opacity: .7;
}

.timeline-content::before {
  content: '';
  position: absolute;
  top: 16px;
  right: 100%;
  height: 0;
  width: 0;
  border: 7px solid transparent;
  border-right: 7px solid white;
}

@media only screen and (min-width: 768px) {
  .timeline-content h2 {
    font-size: 20px;
    font-size: 1.25rem;
  }

  .timeline-content p {
    font-size: 16px;
    font-size: 1rem;
  }


}

@media only screen and (min-width: 1170px) {
  .timeline-content {
    margin-left: 0;
    padding: 1.6em;
    width: 45%;
  }

  .timeline-content::before {
    top: 24px;
    left: 100%;
    border-color: transparent;
    border-left-color: white;
  }

  .timeline-content .read-more {
    float: left;
  }

  .timeline-content .date {
    position: absolute;
    width: 100%;
    left: 122%;
    top: 6px;
  }

  .timeline-block:nth-child(even) .timeline-content {
    float: right;
  }

  .timeline-block:nth-child(even) .timeline-content::before {
    top: 24px;
    left: auto;
    right: 100%;
    border-color: transparent;
    border-right-color: white;
  }

  .timeline-block:nth-child(even) .timeline-content .read-more {
    float: right;
  }

  .timeline-block:nth-child(even) .timeline-content .date {
    left: auto;
    right: 122%;
    text-align: right;
  }

  .cssanimations .timeline-content.is-hidden {
    visibility: hidden;
  }

  .cssanimations .timeline-content.bounce-in {
    visibility: visible;
    -webkit-animation: bounce-2 0.6s;
    -moz-animation: bounce-2 0.6s;
    animation: bounce-2 0.6s;
  }
}

@media only screen and (min-width: 1170px) {
  /* inverse bounce effect on even content blocks */
  .cssanimations .timeline-block:nth-child(even) .timeline-content.bounce-in {
    -webkit-animation: bounce-2-inverse 0.6s;
    -moz-animation: bounce-2-inverse 0.6s;
    animation: bounce-2-inverse 0.6s;
  }
}



</style>

